export default {
  methods: {
    getColorClass(daysBeforeClosing) {
      let nbOfDays;
      if (Array.isArray(daysBeforeClosing)) nbOfDays = daysBeforeClosing[0];
      else nbOfDays = daysBeforeClosing;
      if (nbOfDays <= 7) {
        return 'red';
      }
      if (nbOfDays <= 15 && nbOfDays >= 8) {
        return 'orange';
      } else {
        return 'green';
      }
    },
    formatNullDate(date) {
      return date || '-';
    },
  },
};
